import React, { useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useDispatch } from 'react-redux';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormHelperText,
  Link,
  TextField,
  Typography,
  makeStyles,
  Grid,
  CircularProgress
} from '@material-ui/core';
import Page from 'src/components/Page';
import {
  onboardClientAction,
  signUpUser,
  updateClientAction
} from 'src/store/actions/AuthActions';

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
    // marginTop: theme.spacing(5)
  }
}));

const RegisterView = () => {
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const handleRegisterCompany = async (values) => {
    setLoading(true);
    const response = !state
      ? await dispatch(onboardClientAction(values))
      : await dispatch(updateClientAction(state.id, values));
    setLoading(false);
    if (response.status === 1) {
      navigate('/client-manager');
    }
  };

  const registerValidationSchema = {
    fullname: Yup.string().max(255).required("Compnay's name is required"),
    phone: Yup.number().required('Phone number is required'),
    admin_username: Yup.string()
      .max(255)
      .required('Admin username is required'),
    email: Yup.string()
      .email('Must be a valid email')
      .max(255)
      .required('Email is required'),
    admin_password: Yup.string().max(255).required('Password is required'),
    admin_phone: Yup.number().required('Admin Phone number is required'),
    admin_email: Yup.string().email().required('Admin Email is required'),
    admin_fullname: Yup.string().required('Admin fullname is required')
    // policy: Yup.boolean().oneOf([true], 'This field must be checked')
  };

  const updateClientValidationSchema = {
    fullname: Yup.string().max(255).required("Compnay's name is required"),
    phone: Yup.number().required('Phone number is required')
  };
  return (
    <Page className={classes.root} title="Register">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '',
              fullname: `${state?.fullname || ''}`,
              phone: `${state?.phone || ''}`,
              logo: '',
              admin_password: '',
              admin_username: '',
              admin_phone: '',
              admin_email: '',
              admin_fullname: '',
              admin_profile_picture: 'pics'
              // policy: false
            }}
            validationSchema={Yup.object().shape(
              !state
                ? { ...registerValidationSchema }
                : { ...updateClientValidationSchema }
              // policy: Yup.boolean().oneOf([true], 'This field must be checked')
            )}
            onSubmit={(values) => {
              handleRegisterCompany(values);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={2}>
                  <Typography color="textPrimary" variant="h2">
                    {state ? 'Update ' : 'Create '} Client Account
                  </Typography>
                </Box>
                <Typography color="textPrimary" variant="h4">
                  Company Details
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      error={Boolean(touched.fullname && errors.fullname)}
                      fullWidth
                      helperText={touched.fullname && errors.fullname}
                      label="Company's name"
                      margin="normal"
                      name="fullname"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.fullname}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      error={Boolean(touched.phone && errors.phone)}
                      fullWidth
                      helperText={touched.phone && errors.phone}
                      label="Phone number"
                      margin="normal"
                      name="phone"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.phone}
                      variant="outlined"
                    />
                  </Grid>

                  {!state && (
                    <Grid item xs={12} md={6}>
                      <TextField
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        helperText={touched.email && errors.email}
                        label="Email Address"
                        margin="normal"
                        name="email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="email"
                        value={values.email}
                        variant="outlined"
                      />
                    </Grid>
                  )}
                </Grid>

                {!state && (
                  <>
                    <Typography color="textPrimary" variant="h4">
                      Admin Details
                    </Typography>
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          error={Boolean(
                            touched.admin_username && errors.admin_username
                          )}
                          fullWidth
                          helperText={
                            touched.admin_username && errors.admin_username
                          }
                          label="Username"
                          margin="normal"
                          name="admin_username"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="text"
                          value={values.admin_username}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          error={Boolean(
                            touched.admin_password && errors.admin_password
                          )}
                          fullWidth
                          helperText={touched.admin_password && errors.password}
                          label="Password"
                          margin="normal"
                          name="admin_password"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="password"
                          value={values.admin_password}
                          variant="outlined"
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          error={Boolean(
                            touched.admin_fullname && errors.admin_fullname
                          )}
                          fullWidth
                          helperText={
                            touched.admin_fullname && errors.admin_fullname
                          }
                          label="Admin Fullname"
                          margin="normal"
                          name="admin_fullname"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="admin_fullname"
                          value={values.admin_fullname}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          error={Boolean(
                            touched.admin_phone && errors.admin_phone
                          )}
                          fullWidth
                          helperText={touched.admin_phone && errors.admin_phone}
                          label="Admin Phone"
                          margin="normal"
                          name="admin_phone"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="text"
                          value={values.admin_phone}
                          variant="outlined"
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          error={Boolean(
                            touched.admin_email && errors.admin_email
                          )}
                          fullWidth
                          helperText={touched.admin_email && errors.admin_email}
                          label="Admin Email"
                          margin="normal"
                          name="admin_email"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="email"
                          value={values.admin_email}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </>
                )}

                <Box my={2}>
                  <Button
                    color="primary"
                    disabled={loading}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    {loading && <CircularProgress size="1.5rem" />}
                    &nbsp; Submit
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </Page>
  );
};

export default RegisterView;
